export enum ProductTypeEnum {
  SIMPLE_PRODUCT = 'SimpleProduct',
  CONFIGURABLE_PRODUCT = 'ConfigurableProduct',
  BUNDLE_PRODUCT = 'BundleProduct',
  GROUPED_PRODUCT = 'GroupedProduct',
}

export enum EngravingPlacementEnum {
  'Gravur auf Clip' = 'clip',
  'Gravur auf dem Schaft' = 'shaft',
}

export enum EngravingFontEnum {
  'Schreibschrift' = 'handwriting',
  'Druckschrift' = 'normal',
  'Druckschrift kursiv' = 'italic',
  'Druckschrift Großbuchstaben' = 'capitalize',
}
